export default __webpack_public_path__ + "static/media/SZ02.7abcede4.mp3";